import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import moment from "moment-jalaali";
import Pagination from "react-js-pagination";
import Loading from "../Loading/Loading";
import { toast } from "react-toastify";

export default function BlockedSmsLimit() {
  const [data, setData] = useState(undefined);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies();
  const [filters, setFilters] = useState([
    {
      key: "id",
      value: null,
    },
    {
      key: "mobile",
      value: null,
    }, 
    {
      key: "data",
      value: null,
    },
  ]);
  useEffect(() => {
    getData();
  }, []);
  function getData(page = 1) {
    setLoading(true);
    let filterUrl = "&";
    filters.map((item) => {
      if (item.value != null) filterUrl += `filter[${item.key}]=${item.value}&`;
    });

    const url = Constants.apiUrl + "/api/block/mobile?page="+page + filterUrl;
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setData(r.data.data);
        setLoading(false);

        console.log(r);
      })
      .catch((e) => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getData(1);
  }, [filters]);

  function filterHandle(e) {
    let key = e.target.name;
    let value = e.target.value;
    let oldValue = "";
    const newFilter = filters.map((obj) => {
      if (obj.key == key) {
        oldValue = obj.value;
        return { ...obj, value: value };
      }
      return obj;
    });
    if (oldValue != value) setFilters(newFilter);
  }


  const  unblockHandle=(mobile)=>{
    const url = Constants.apiUrl + "/api/sms-limit/unblock";
    axios
      .post(url,{mobile:mobile} ,{
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {  
        getData(data.current_page)
        toast.success("شماره با موفقیت آنبلاک شد")
      })
      .catch((e) => {
        toast.error("خطایی در عملیات پیش آمد")

      });
  }
  return (
    <>
      <Breadcrumb title={"مدیریت شماره های بلاک شده"} />
      {loading && <Loading />}

      <div className="table-responsive mt-5 mb-5">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <td>شناسه</td>
              <td> موبایل </td> 
              <td> </td>
            </tr>
            <tr className={" "}>
              <th>
                <input
                  name={"id"}
                  onBlur={filterHandle}
                  type={"text"}
                  className={"form-control text-center"}
                />
              </th>
              <th>
                <input
                  name={"mobile"}
                  onBlur={filterHandle}
                  type={"text"}
                  className={"form-control text-center"}
                />
              </th> 
              <th></th>
            </tr>
          </thead>
          {data &&
            data.data &&
            data.data.map((item) => {
              return (
                <tr>
                  <td>{item.id}</td>
                  <td>{item.mobile}</td> 

                  <td>
                    <button className="btn btn-warning" onClick={() => {
                        unblockHandle(item.mobile);
                    }}>
                      آنبلاک
                    </button>
                  </td>
                </tr>
              );
            })}
        </table>
        {data && (
          <div className="pager Page navigation example">
            <Pagination
              totalItemsCount={data.total}
              activePage={data.current_page}
              itemsCountPerPage={data.per_page}
              onChange={(number) => {
                getData(number);
              }}
              itemClass="page-item"
              linkClass="page-link"
              firstPageText="اولین صفحه"
              lastPageText="آخرین صفحه"
              nextPageText="بعدی"
              prevPageText="قبلی"
              activeClass="pageactive"
            />
          </div>
        )}
      </div>
    </>
  );
}
